// Port of api/fuel/app/classes/filter/search/games/filters/query/game/version/name.php
import Rule from 'offline/filter/core/search/rule'

export default {
	name: 'version.name',
	priority: 80,
	require: function(config, filter) { return filter.version && filter.version.name && filter.version.name.length > 0 },
	run: function(config, filter, data, query) {
		var keywords = Rule.getKeywords(filter.version.name)
		for (var i = 0; i < keywords.length; i++) {
			query.whereGroup('OR', [
				['v.game_version_name', 'like', '%' + keywords[i] + '%'],
				['v.game_version_localised', 'like', '%' + keywords[i] + '%']
			])
		}
	}
}
